export const KNOWLEDGE_BASE_LANDING_TAB_VALUES = ["projects", "playbook", "templates"] as const;

export type KnowledgeBaseLandingTab = (typeof KNOWLEDGE_BASE_LANDING_TAB_VALUES)[number];

export const DEFAULT_KNOWLEDGE_BASE_LANDING_TAB: KnowledgeBaseLandingTab = "projects";

const KNOWLEDGE_BASE_LANDING_TAB_SET = new Set<string>(KNOWLEDGE_BASE_LANDING_TAB_VALUES);

export const isKnowledgeBaseLandingTab = (
  value: string | null | undefined,
): value is KnowledgeBaseLandingTab =>
  value !== null && value !== undefined && KNOWLEDGE_BASE_LANDING_TAB_SET.has(value);

export const getKnowledgeBaseLandingTab = (
  value: string | null | undefined,
): KnowledgeBaseLandingTab =>
  isKnowledgeBaseLandingTab(value) ? value : DEFAULT_KNOWLEDGE_BASE_LANDING_TAB;

export const shouldNormalizeKnowledgeBaseLandingTab = (value: string | null | undefined): boolean =>
  value !== null &&
  value !== undefined &&
  (!isKnowledgeBaseLandingTab(value) || value === DEFAULT_KNOWLEDGE_BASE_LANDING_TAB);

export const withKnowledgeBaseLandingTab = (
  searchParams: URLSearchParams,
  tab: KnowledgeBaseLandingTab,
): URLSearchParams => {
  const nextSearchParams = new URLSearchParams(searchParams);

  if (tab === DEFAULT_KNOWLEDGE_BASE_LANDING_TAB) {
    nextSearchParams.delete("tab");
  } else {
    nextSearchParams.set("tab", tab);
  }

  return nextSearchParams;
};

export const getKnowledgeBaseLandingBreadcrumbTab = ({
  orgId,
  pathname,
  search,
}: {
  orgId?: string;
  pathname: string;
  search: string;
}): Exclude<KnowledgeBaseLandingTab, "projects"> | null => {
  if (!orgId || pathname !== `/${orgId}/knowledge-base`) {
    return null;
  }

  const tab = getKnowledgeBaseLandingTab(new URLSearchParams(search).get("tab"));

  return tab === "projects" ? null : tab;
};
